import lb from '@/lib/loopback';

export function create(log) {
  return lb.post('/Logs', log, {
    headers: {
      save: true,
    },
  });
}

export default {
  $api: {
    create,
  },
};
